import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ThemeWrapper from "./ThemeWrapper";
import Dashboard from "./components/Dashboard/Dashboard";
import AuthRoute from "./AuthRoute";
import { UserProvider } from "./contexts/UserContext";
import CognitoRedirect from "./components/Auth/CognitoRedirect";
import VerifyAccount from "./components/Auth/VerifyAccount";
import Layout from "./components/Common/Layout";
import CampaignOverview from "./components/Campaigns/CampaignOverview";
import UpdatePassword from "./components/Auth/UpdatePassword";
import Profile from "./components/Auth/Profile";
import OrganizationProfile from "./components/Organization/OrganizationProfile";
import AuthCallback from "./components/Auth/AuthCallback";
import SubscriptionSuccess from "./components/Subscription/SubscriptionSuccess";
import SubscriptionCancel from "./components/Subscription/SubscriptionCancel";

const App: React.FC = () => {
  return (
    <ThemeWrapper>
      <Router basename={process.env.PUBLIC_URL || '/'} future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
        <UserProvider>
          <Routes>
            <Route path="/login" element={<CognitoRedirect />} />
            <Route path="/signup" element={<CognitoRedirect />} />
            <Route path="/verify" element={<VerifyAccount />} />
            <Route path="/auth/callback" element={<AuthCallback />} />

            {/* Wrap protected routes with AuthRoute */}
            <Route
              path="/"
              element={
                <AuthRoute>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </AuthRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <AuthRoute>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </AuthRoute>
              }
            />
            <Route
              path="/campaigns/:organizationId/:campaignId/*"
              element={
                <AuthRoute>
                  <Layout>
                    <CampaignOverview />
                  </Layout>
                </AuthRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <AuthRoute>
                  <Layout>
                    <Profile />
                  </Layout>
                </AuthRoute>
              }
            />
            <Route
              path="/update-password"
              element={
                <AuthRoute>
                  <Layout>
                    <UpdatePassword />
                  </Layout>
                </AuthRoute>
              }
            />
            {/* Routes for organization profile */}
            <Route
              path="/organizations"
              element={
                <AuthRoute>
                  <Layout>
                    <OrganizationProfile />
                  </Layout>
                </AuthRoute>
              }
            />
            <Route
              path="/organizations/new"
              element={
                <AuthRoute>
                  <Layout>
                    <OrganizationProfile />
                  </Layout>
                </AuthRoute>
              }
            />
            <Route
              path="/organizations/:id"
              element={
                <AuthRoute>
                  <Layout>
                    <OrganizationProfile />
                  </Layout>
                </AuthRoute>
              }
            />
            <Route
              path="/organization/profile"
              element={
                <AuthRoute>
                  <Layout>
                    <OrganizationProfile />
                  </Layout>
                </AuthRoute>
              }
            />

            {/* Stripe Checkout Routes */}
            <Route
              path="/subscription/success"
              element={
                <AuthRoute>
                  <Layout>
                    <SubscriptionSuccess />
                  </Layout>
                </AuthRoute>
              }
            />
            <Route
              path="/subscription/cancel"
              element={
                <AuthRoute>
                  <Layout>
                    <SubscriptionCancel />
                  </Layout>
                </AuthRoute>
              }
            />
          </Routes>
        </UserProvider>
      </Router>
    </ThemeWrapper>
  );
};

export default App;
